var l={label:"styles-module_label__d1o6t"};export{l as default};
//# sourceMappingURL=styles.module.scss.js.map
